/**
 * Upload error log (owner 2026-10-19).
 *
 * A photo the browser cannot read never reaches the Worker, so "We couldn't
 * read this file" left staff nothing to look at. Each failed photo is beaconed
 * to POST /projects/:id/upload-errors with what the browser saw (name, MIME,
 * size, sniffed container, first 16 bytes, the decoder's own error) and staff
 * look it up via GET /lab/upload-errors?q=<email | file name>.
 *
 * Fire-and-forget: every failure is swallowed, ordering must never break.
 */
import { DecodeError } from './decode';

const BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? '/apps/print/api';

export function reportUploadError(
  handle: { id: string; token: string } | null,
  file: File,
  err: unknown,
): void {
  if (!handle) return;
  try {
    const de = err instanceof DecodeError ? err : null;
    const detail = de
      ? de.detail
      : err instanceof Error
        ? `${err.name}: ${err.message}`
        : String(err);
    const payload = {
      file_name: file.name,
      file_type: file.type,
      file_bytes: file.size,
      sniffed: de?.sniffed,
      head_hex: de?.headHex,
      reason: de ? de.reason : 'other',
      detail,
    };
    void fetch(`${BASE}/projects/${handle.id}/upload-errors`, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'X-RPL-Project-Token': handle.token },
      body: JSON.stringify({ errors: [payload] }),
    }).catch(() => undefined);
  } catch {
    /* never break the app for diagnostics */
  }
}
